import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateDeedOfAbsoluteSale.json';
import FormError from '../../../../view/FormError';
import {TinFormat} from '../../../../model/Helper';
import Meta from '../../../../model/Meta';

class DeedOfAbsoluteSaleStep2 extends Component {

	constructor(props) {
		super(props);
		this.state = Data;
		
		this.handleUserChange = this.handleUserChange.bind(this);
		this.handleAddUser = this.handleAddUser.bind(this);
		this.handleRemoveUser = this.handleRemoveUser.bind(this);
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));

					// Initialize errors and callbacks
					this.errorHandle();
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
			//console.log("State default: ", this.state);
			//console.log("Storage default: ", data);
		}

    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleAddUser(event) {

		/**
		 * Add new seller object on array
		 */
		this.state.details.seller.push(...Data.details.seller);
		
		/**
		 * Clever way to update all components with state
		 */
		this.setState(this.state,()=>{

			//console.log("State Change: ", this.state);
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));

			this.setState({
				...this.state,
				addSeller: "No"
			});

			this.errorHandle();

		});

	}

	handleRemoveUser(e, i) {
		e.preventDefault();
		let toArray = [...this.state.details.seller];
		toArray.splice(i, 1);
		this.setState({
			details: {
				property: this.state.details.property,
				seller: toArray,
				buyer: this.state.details.buyer,
				payment: this.state.details.payment
			},
			formFocus: this.state.formFocus
		}, ()=>{
				//console.log("State Change: ", this.state);
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
					
				this.setState({
					addSeller: "No"
				})

				this.errorHandle();
		});
	}

	handleUserChange(e, i, radioName=null) {

		/**
		 * Passing name props for radio buttons
		 * Having issues with radio buttons when in array map
		 */
		const target = e.target;
		let value = target.type === 'checkbox' ? target.checked : target.value;
		const name = radioName ? radioName : target.name;

		if(name==="sellerTin"){
			if(value.length>15){
				value = this.state.details.seller[i].sellerTin;
			}
		}

		if(name==="sellerSpouseTin"){
			if(value.length>15){
				value = this.state.details.seller[i].sellerSpouseTin;
			}
		}

		if(name==="sellerCorporationTin"){
			if(value.length>15){
				value = this.state.details.seller[i].sellerCorporationTin;
			}
		}

		let sellerArray = [...this.state.details.seller];
		sellerArray[i][name] = value;

		this.setState({
			details: {
				property: this.state.details.property,
				seller: sellerArray,
				buyer: this.state.details.buyer,
				payment: this.state.details.payment
			},
			formFocus: `seller_${name}-${i}`,
			formFocusSellerNo: i
		},
			()=>{
				//console.log("Handle user change: ", this.state.details.seller);
				//console.log("Focus target: ", this.state.formFocus+this.state.formFocusSellerNo);
				this.setState(this.state);
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				this.errorHandle();

			}
		);
	}
	
	errorHandle(callback = null) {
		// Check if we have a user seller
		let errorArray = [];

		if(this.state.details.seller.length>0) {
			this.state.details.seller.forEach((obj, i)=>{
				
				// Check legal peronality
				if(this.state.details.seller[i].legalPersonality!==""){
					// Natural person block error
					if(this.state.details.seller[i].legalPersonality==="Natural Person"){
						// Check if legal age
						if(this.state.details.seller[i].isLegalAge==="Yes"){
							// Check seller name
							if(
								this.state.details.seller[i].sellerFname==="" ||
								this.state.details.seller[i].sellerMname==="" ||
								this.state.details.seller[i].sellerLname===""
							){
								let err = {
									"message": `Seller #${i+1}: Please complete name.`
								}
								errorArray.push(err);
							}
							// Check seller gender
							if(this.state.details.seller[i].sellerGender===""){
								let err = {
									"message": `Seller #${i+1}: Please select gender.`
								}
								errorArray.push(err);
							}
							// Check seller marital status
							if(this.state.details.seller[i].sellerMaritalStatus===""){
								let err = {
									"message": `Seller #${i+1}: Please select marital status.`
								}
								errorArray.push(err);
							} else {
								// If married check spouse full name
								if(this.state.details.seller[i].sellerMaritalStatus==="Married") {
									if(
										this.state.details.seller[i].sellerSpouseFname==="" ||
										this.state.details.seller[i].sellerSpouseMname==="" ||
										this.state.details.seller[i].sellerSpouseLname===""
									){
										let err = {
											"message": `Seller #${i+1}: Please complete spouse name.`
										}
										errorArray.push(err);
									}
								}
							}
							// Check seller address
							if(this.state.details.seller[i].sellerAddress===""){
								let err = {
									"message": `Seller #${i+1}: Please complete address.`
								}
								errorArray.push(err);
							}
							// Check seller nationality
							if(this.state.details.seller[i].sellerNationality===""){
								let err = {
									"message": `Seller #${i+1}: Please complete nationality.`
								}
								errorArray.push(err);
							}
							// Check representative option
							if(this.state.details.seller[i].sellerHasRepresentative==="Yes"){
								// Check seller representative full name
								if(
									this.state.details.seller[i].sellerRepresentativeFname==="" ||
									this.state.details.seller[i].sellerRepresentativeMname==="" ||
									this.state.details.seller[i].sellerRepresentativeLname===""
								){
									let err = {
										"message": `Seller #${i+1}: Please complete representative name.`
									}
									errorArray.push(err);
								}
								// Check seller representative address
								if(this.state.details.seller[i].sellerRepresentativeAddress===""){
									let err = {
										"message": `Seller #${i+1}: Please complete representative address.`
									}
									errorArray.push(err);
								}

								// Check seller representative nationality
								if(this.state.details.seller[i].sellerRepresentativeNationality===""){
									let err = {
										"message": `Seller #${i+1}: Please complete representative nationality.`
									}
									errorArray.push(err);
								}

							}

						} else {
							let err = {
								"message": `Seller #${i+1}: Is not legal age.`
							}					
							errorArray.push(err);
						}

					}
					
					// Check corporation block
					if(this.state.details.seller[i].legalPersonality==="Corporation"){
						// Check corporation name
						if(this.state.details.seller[i].sellerCorporationName===""){
							let err = {
								"message": `Seller #${i+1}: Please complete corporation name.`
							}
							errorArray.push(err);
						}
						// Check principal place of business
						if(this.state.details.seller[i].sellerCorporationPrincipalPlaceOfBusiness===""){
							let err = {
								"message": `Seller #${i+1}: Please complete corporation principal place of business.`
							}
							errorArray.push(err);
						}
						// Check corporation representative
						if(
							this.state.details.seller[i].sellerCorporationRepresentativeFname==="" ||
							this.state.details.seller[i].sellerCorporationRepresentativeMname==="" ||
							this.state.details.seller[i].sellerCorporationRepresentativeLname===""
						){
							let err = {
								"message": `Seller #${i+1}: Please complete corporation representative name.`
							}
							errorArray.push(err);
						}
						// Check corporation representative position
						if(this.state.details.seller[i].sellerCorporationRepresentativePosition===""){
							let err = {
								"message": `Seller #${i+1}: Please complete position of the representative.`
							}
							errorArray.push(err);
						}

					}

				} else {
					let err = {
						"message": `Please select legal personality for seller #${i+1}.`
					}
					errorArray.push(err);
				}
				
			});

			//console.log("Going to state: ", errorArray)

			this.setState({
				formError: errorArray
			},(i)=>{
				////console.log("Error handle: ", this.state )
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				this.checkCompleteness();			
				this.state.details.seller.map((obj, i)=>this.elementsShowHide(i));			
			})
		}
	}

    checkCompleteness() {

		if(this.state.formError.length>0) {
			$(".next").addClass("disabled");
		} else {
			$(".next").removeClass("disabled");
		}
			
	}

	elementsShowHide(i) {

		if(typeof this.state.details.seller[i] === 'undefined') {
			// Do nothing
		} else {

			/**
			 * Show/hide natural person block
			 */
			if(this.state.details.seller[i].legalPersonality==="Natural Person"){
				$(".seller_"+i+" .natural-person").removeClass("d-none");

				/**
				 * Hide everything else if seller is below legal age
				 */
				if(this.state.details.seller[i].isLegalAge==="Yes"){
					$(".seller_"+i+" .requireLegalAge").removeClass("d-none");
					$(".seller_"+i+" .isNotLegalAge").addClass("d-none");
				} else {
					$(".seller_"+i+" .requireLegalAge").addClass("d-none");
					$(".seller_"+i+" .isNotLegalAge").removeClass("d-none");
				}

				/**
				 * Hide representative if no representative
				 */
				if(
					this.state.details.seller[i].sellerHasRepresentative==="Yes" && 
					this.state.details.seller[i].isLegalAge==="Yes"){
					$(".seller_"+i+" .requireHasRepresentative").removeClass("d-none");
				} else {
					$(".seller_"+i+" .requireHasRepresentative").addClass("d-none");
				}

				/**
				 * Hide spouse block if single
				 */
				if(
					this.state.details.seller[i].isLegalAge==="Yes" && 
					this.state.details.seller[i].sellerMaritalStatus==="Married"){
					$(".seller_"+i+" .requireMarried").removeClass("d-none");
				} else {
					$(".seller_"+i+" .requireMarried").addClass("d-none");
				}


			} else {
				$(".seller_"+i+" .natural-person").addClass("d-none");
			}

			/**
			 * Show/hide corporation block
			 */
			if(this.state.details.seller[i].legalPersonality === "Corporation"){
				$(".seller_"+i+" .corporation").removeClass("d-none");
			} else {
				$(".seller_"+i+" .corporation").addClass("d-none");	
			}

			/**
			 * Hide error block if there is no error
			 */
			if(this.state.formError.length>0){
				////console.log("has error");
				$(".form-error").removeClass("d-none");
				$(".new-seller").addClass("d-none");
			} else {
				////console.log("no error");
				$(".form-error").addClass("d-none");
				$(".new-seller").removeClass("d-none");
			}

		}

	}

	sellerFields(arr) {
		
		let formFields = arr;

		return (	
			<div>

				{
					formFields.map((obj, i)=>{
						return (
							<div key={i} className={"seller_"+i}>
								
								{(formFields.length>1) ? 
									<div>
										{
											(i > 0) ? <hr className="mt-3" /> : null
								   		}
										<div className="row pt-3 pb-2">
											<div className="col-6">
												<h5>Seller #{i+1}</h5>
											</div>
											<div className="col-6 text-right">
												<p><a onClick={(e)=>this.handleRemoveUser(e, i)}>Delete this seller</a></p>
											</div>
										</div>
									</div>  : 
									null
								}
								
								<div>
									<p className="label"><strong>What is the legal personality of the seller?<span className="red asterisk">*</span></strong></p>
									<div className="row">
										<div className="col-6">
											<div className="form-check form-check-inline mr-2">
												<label className="form-check-label">
													<input 
														className="form-check-input" 
														type="radio"
														value="Natural Person" 
														onChange={(e)=>this.handleUserChange(e, i, "legalPersonality")}
														checked={obj.legalPersonality === 'Natural Person'} 
													/>
														Natural Person
													</label>
											</div>
										</div>
										<div className="col-6">
											<div className="form-check form-check-inline ml-2">
												<label className="form-check-label">
													<input 
														className="form-check-input" 
														type="radio" 
														value="Corporation" 
														onChange={(e)=>this.handleUserChange(e, i, "legalPersonality")}
														checked={obj.legalPersonality === 'Corporation'} 
													/>
														Corporation
													</label>
											</div>
										</div>
									</div>
								</div>

								{/** Start Natural person block */}
								<div className="natural-person d-none">
									<div>
										<p className="label"><strong>Is the seller at least 18 years of age?<span className="red asterisk">*</span></strong></p>
										<div className="row">
											<div className="col-6">
												<div className="form-check form-check-inline mr-2">
													<label className="form-check-label">
														
														<input 
															className="form-check-input" 
															type="radio" 
															value="Yes"
															onChange={(e)=>this.handleUserChange(e, i, "isLegalAge")}
															checked={obj.isLegalAge==="Yes"}
														/>
															Yes
														</label>
												</div>
											</div>
											<div className="col-6">
												<div className="form-check form-check-inline ml-2">
													<label className="form-check-label">
														<input 
															className="form-check-input" 
															type="radio" 
															value="No"
															onChange={(e)=>this.handleUserChange(e, i, "isLegalAge")}
															checked={obj.isLegalAge==="No"}
														/>
															No
														</label>
												</div>
											</div>
										</div>
									</div>

									{/** Is legal age */}
									<div className="isNotLegalAge requireLegalPersonality d-none">
										<br />
										<p className="alert alert-warning">The seller must at least be 18 years of age for the contract to be valid.</p>
									</div>

									{/** Name of seller */}
									<div className="requireLegalAge">
										<br />
										<div className="form-group">
											<label htmlFor="sellerName">
												<span className="font-weight-bold">Name of the seller?</span><span className="red asterisk">*</span>
											</label>
											<input className="form-control" name="sellerFname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerFname} placeholder="First Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerMname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerMname} placeholder="Middle Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerLname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerLname} placeholder="Last Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerSuffix" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerSuffix} placeholder="Suffix" />
										</div>

										<div className="text-center">
											<div className="form-check form-check-inline mr-2">
												<label className="form-check-label">
													<input 
														className="form-check-input" 
														type="radio" 
														value="Male" 
														onChange={(e)=>this.handleUserChange(e, i, "sellerGender")} 
														checked={obj.sellerGender === 'Male'} 
													/>
														Male
													</label>
											</div>
											<div className="form-check form-check-inline ml-2">
												<label className="form-check-label">
													<input 
														className="form-check-input" 
														type="radio" 
														value="Female" 
														onChange={(e)=>this.handleUserChange(e, i, "sellerGender")} 
														checked={obj.sellerGender === 'Female'} 
													/>
														Female
													</label>
											</div>
										</div>

									</div>

									{/** TIN */}
									<div className="requireLegalAge">
										<div className="form-group">
											<label htmlFor="">
												<span className="font-weight-bold">Tax Identification Number (TIN) of the seller [Optional]:</span>
											</label>
											<input className="form-control" name="sellerTin" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={TinFormat(obj.sellerTin)} placeholder="(e.g. 123-456-789-000)" />
										</div>
									</div>

									{/** Marital status */}
									<div className="requireLegalAge">
										<br />
										<p className="label"><strong>Marital status of the seller:<span className="red asterisk">*</span></strong></p>
										<div className="row">
											<div className="col-6">	
												<div className="form-check form-check-inline mr-2">
													<label className="form-check-label">
														<input 
															className="form-check-input" 
															type="radio" 
															value="Single" 
															onChange={(e)=>this.handleUserChange(e, i, "sellerMaritalStatus")} 
															checked={obj.sellerMaritalStatus === 'Single'} 
														/>
															Single
														</label>
												</div>
											</div>
											<div className="col-6">
												<div className="form-check form-check-inline ml-2">
													<label className="form-check-label">
														<input 
															className="form-check-input" 
															type="radio" 
															value="Married" 
															onChange={(e)=>this.handleUserChange(e, i, "sellerMaritalStatus")} 
															checked={obj.sellerMaritalStatus === 'Married'} 
														/>
															Married
														</label>
												</div>
											</div>
										</div>
									</div>

									{/** Spouse info */}
									<div className="requireLegalAge requireMarried d-none">
										<div className="form-group">
											<label htmlFor="sellerName">
												<span className="font-weight-bold">Name of spouse?</span><span className="red asterisk">*</span>
											</label>
											<input className="form-control" name="sellerSpouseFname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerSpouseFname} placeholder="First Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerSpouseMname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerSpouseMname} placeholder="Middle Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerSpouseLname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerSpouseLname} placeholder="Last Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerSpouseSuffix" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerSpouseSuffix} placeholder="Suffix" />
										</div>
										<div className="form-group">
											<label htmlFor="sellerSpouseTin">
												<span className="font-weight-bold">Tax Identification Number (TIN) of the spouse [Optional]:</span>
											</label>
											<input className="form-control" name="sellerSpouseTin" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={TinFormat(obj.sellerSpouseTin)} placeholder="(e.g. 123-456-789-000)" />
										</div>
									</div>

									{/** Seller address */}
									<div className="requireLegalAge">
										<br />
										<div className="form-group">
											<label htmlFor="sellerAddress">
												<span className="font-weight-bold">Address of the seller: <span className="red asterisk">*</span></span>
											</label>
											<input className="form-control" name="sellerAddress" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerAddress} placeholder="(e.g. No. Street, City, Province, Country, Zip Code" />
										</div>
									</div>

									{/** Seller Nationality */}
									<div className="requireLegalAge">
										<div className="form-group">
											<label htmlFor="sellerNationality">
												<span className="font-weight-bold">Nationality of the seller: <span className="red asterisk">*</span></span>
											</label>
											<input className="form-control" name="sellerNationality" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerNationality} placeholder="(e.g. Filipino)" />
										</div>
									</div>

									{/** Has representative? */}
									<div className="requireLegalAge">
										<br />
										<p className="label"><strong>Will the seller have a representative to execute the contract? <span className="red asterisk">*</span></strong></p>
										<div className="row">
											<div className="col-6">	
												<div className="form-check form-check-inline mr-2">
													<label className="form-check-label">
														<input 
															className="form-check-input" 
															type="radio" 
															value="Yes" 
															onChange={(e)=>this.handleUserChange(e, i, "sellerHasRepresentative")} 
															checked={obj.sellerHasRepresentative === 'Yes'} 
														/>
															Yes
														</label>
												</div>
											</div>
											<div className="col-6">
												<div className="form-check form-check-inline ml-2">
													<label className="form-check-label">
														<input 
															className="form-check-input" 
															type="radio" 
															value="No" 
															onChange={(e)=>this.handleUserChange(e, i, "sellerHasRepresentative")} 
															checked={obj.sellerHasRepresentative === 'No'} 
														/>
															No
														</label>
												</div>
											</div>
										</div>
									</div>

									{/** Representative name */}
									<div className="requireLegalAge requireHasRepresentative">
										<div className="form-group">
											<label htmlFor="sellerRepresentativeFname">
												<span className="font-weight-bold">Name of the representative?</span><span className="red asterisk">*</span>
											</label>
											<input className="form-control" name="sellerRepresentativeFname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerRepresentativeFname} placeholder="First Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerRepresentativeMname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerRepresentativeMname} placeholder="Middle Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerRepresentativeLname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerRepresentativeLname} placeholder="Last Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerRepresentativeSuffix" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerRepresentativeSuffix} placeholder="Suffix" />
										</div>
									</div>

									{/** Seller representative address */}
									<div className="requireLegalAge requireHasRepresentative">
										<div className="form-group">
											<label htmlFor="sellerRepresentativeAddress">
												<span className="font-weight-bold">Address of the representative: <span className="red asterisk">*</span></span>
											</label>
											<input className="form-control" name="sellerRepresentativeAddress" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerRepresentativeAddress} placeholder="(e.g. No. Street, City, Province, Country, Zip Code" />
										</div>
									</div>

									{/** Seller representative nationality */}
									<div className="requireLegalAge requireHasRepresentative">
										<div className="form-group">
											<label htmlFor="sellerRepresentativeNationality">
												<span className="font-weight-bold">Nationality of the representative: <span className="red asterisk">*</span></span>
											</label>
											<input className="form-control" name="sellerRepresentativeNationality" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerRepresentativeNationality} placeholder="(e.g. Filipino" />
										</div>
									</div>

								</div>
								{/** Natural person block ends */}

								{/** Start corporation block */}
								<div className="corporation d-none">
									
									{/** Seller Nationality */}
									<div>
										<br />
										<div className="form-group">
											<label htmlFor="sellerCorporationName">
												<span className="font-weight-bold">Name of the corporation: <span className="red asterisk">*</span></span>
											</label>
											<input className="form-control" name="sellerCorporationName" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerCorporationName} placeholder="(e.g. ABC corp.)" />
										</div>
									</div>

									{/** Seller corporation tin */}
									<div>
										<div className="form-group">
											<label htmlFor="sellerCorporationTin">
												<span className="font-weight-bold">Tax Identification Number (TIN) of the seller [Optional]: </span>
											</label>
											<input className="form-control" name="sellerCorporationTin" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={TinFormat(obj.sellerCorporationTin)} placeholder="(e.g. 123-456-789-000)" />
										</div>
									</div>

									{/** Seller corporation principal place of business */}
									<div>
										<div className="form-group">
											<label htmlFor="sellerCorporationPrincipalPlaceOfBusiness">
												<span className="font-weight-bold">Principal place of business of the seller: <span className="red asterisk">*</span> </span>
											</label>
											<input className="form-control" name="sellerCorporationPrincipalPlaceOfBusiness" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerCorporationPrincipalPlaceOfBusiness} placeholder="(e.g. No. Street, City, Province, Coutry, Zip Code)" />
										</div>
									</div>

									{/** Seller corporation representative block */}
									<div>
										<div className="form-group">
											<label htmlFor="sellerCorporationRepresentativeFname">
												<span className="font-weight-bold">Name of the authorized representative of the seller:</span><span className="red asterisk">*</span>
											</label>
											<input className="form-control" name="sellerCorporationRepresentativeFname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerCorporationRepresentativeFname} placeholder="First Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerCorporationRepresentativeMname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerCorporationRepresentativeMname} placeholder="Middle Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerCorporationRepresentativeLname" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerCorporationRepresentativeLname} placeholder="Last Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="sellerCorporationRepresentativeSuffix" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerCorporationRepresentativeSuffix} placeholder="Suffix" />
										</div>
									</div>

									{/** Seller corporation representative position */}
									<div>
										<div className="form-group">
											<label htmlFor="sellerCorporationRepresentativePosition">
												<span className="font-weight-bold">Position of the authorized representative of the seller: <span className="red asterisk">*</span></span>
											</label>
											<input className="form-control" name="sellerCorporationRepresentativePosition" type="text" onChange={(e)=>this.handleUserChange(e, i)} value={obj.sellerCorporationRepresentativePosition} placeholder="(e.g. President" />
										</div>
									</div>


								</div>
								{/** End corporation block*/}
								
							</div>
						)
					})
				}
			</div>
		)
	}

    render() {
			const meta = {
				title: "Seller Information - Deed of Absolute Sale Contract",
				description: "Enter seller information to create your custom Deed of Absolute Sale Contract"
			}
        return(
            <div className="page page-inner page-contract">
							<Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((2/6)*100)} />

                                <form>
                                    
									{this.sellerFields(this.state.details.seller)}
									
									{/** Will there be another seller */}	
									<hr />
									<div className="new-seller">	
										<br />
										<p className="label"><strong>Will there be another seller?</strong></p>
										<div className="row">
											<div className="col-6">	
												<div className="form-check form-check-inline mr-2">
													<label className="form-check-label">
														<input className="form-check-input" type="radio" name="addSeller" value="Yes" onChange={this.handleAddUser} checked={this.state.addSeller === 'Yes'} />
															Yes
														</label>
												</div>
											</div>
											<div className="col-6">
												<div className="form-check form-check-inline ml-2">
													<label className="form-check-label">
														<input className="form-check-input" type="radio" name="addSeller" value="No" onChange={this.handleAddUser} checked={this.state.addSeller === 'No'} />
															No
														</label>
												</div>
											</div>
										</div>
									</div>

                                </form>

                                {/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 2/6</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath+"/1"} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/3"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>
                            
                            </div>

                            <div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>
                         
                        </div>
                    </div>
                </div>
            </div>

        )
    }
    
}

export default DeedOfAbsoluteSaleStep2;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/deed-of-absolute-sale/DeedOfAbsoluteSaleStep2.js